const OnBeforeRouteResolveHook = Symbol('OnBeforeRouteResolveHook')

export function onBeforeRouteResolve (onBeforeRouteResolveHook) {
  return function compose (component) {
    return Object.assign(component, {
      [OnBeforeRouteResolveHook]: onBeforeRouteResolveHook
    })
  }
}

export function resolveBeforeRouteResolveHook (component) {
  return component[OnBeforeRouteResolveHook]
}

export function RedirectedError (redirectTo) {
  this.message = 'redirected failure'
  this.redirectTo = redirectTo
}

export function redirect (url) {
  throw new RedirectedError(url)
}
